// extracted by mini-css-extract-plugin
export default {"new-game":"style_new-game__6QZvz","neon-sign":"style_neon-sign__SSR3T"};